import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "Not enough rest (under 5 hours)",
    displayValue: "Not enough rest (under 5 hours)",
    emoji: img1,
  },
  {
    value: "Some sleep (5-6 hours) ",
    displayValue: "Some sleep (5-6 hours) ",
    emoji: img2,
  },
  {
    value: "A good rest (7-8 hours) ",
    displayValue: "A good rest (7-8 hours) ",
    emoji: img3,
  },
  {
    value: "I'm an expert sleeper (more than 8 hours)",
    displayValue: "I'm an expert sleeper (more than 8 hours)",
    emoji: img4,
  },
];
export const AverageNight = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.averageNight, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Truthfully, what is an average night like for you?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
